module.exports = __webpack_public_path__ + "collapse-hover.5d121f.svg";